import {createContext, useContext} from 'react';

const PageTextContext = createContext();

const PageTextProvider = ({children, value}) => {
  return <PageTextContext.Provider value={value}>{children}</PageTextContext.Provider>;
};

const usePageText = () => {
  const context = useContext(PageTextContext);
  if (context === undefined) {
    throw new Error('usePageText must be used within a PageTextProvider');
  }
  return context;
};

export {usePageText, PageTextProvider};
